export default "__VITE_PUBLIC_ASSET__1e2e0585__"